import axios, {AxiosResponse, CancelToken} from 'axios';
import {CANCEL} from 'redux-saga';

import Url from '../constants/Url';

class TotalLifetimePlaysApi {
    getData(params) {
        const source = axios.CancelToken.source();
        const cancelToken: CancelToken = source.token;

        const request: Promise<AxiosResponse<string>> = axios
            .get(Url().GET_TOTAL_LIFETIME_PLAYS, {params, cancelToken})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getData:', ex.message);
                throw ex;
            });

        request[CANCEL] = () => source.cancel();

        return request;
    }

    getDataOverview({value, ...params}) {
        const source = axios.CancelToken.source();
        const cancelToken: CancelToken = source.token;

        const request: Promise<AxiosResponse<string>> = axios
            .get(Url().GET_TOTAL_LIFETIME_PLAYS_OVERVIEW(value), {params, cancelToken})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getDataOverview:', ex.message);
                throw ex;
            });

        request[CANCEL] = () => source.cancel();

        return request;
    }
}

export default new TotalLifetimePlaysApi();
